module.exports = __webpack_public_path__ + "static/media/excel.b3874c6f.svg";